import React from 'react';
import {Box, Typography} from '@mui/material';
import {InboxOutlined} from '@mui/icons-material';
import {t} from '../../themes/statamicTokens';

/**
 * Placeholder for empty lists / tabs / sections. Use instead of plain
 * "No results" strings.
 *
 * Props:
 *   icon        — optional React element (defaults to Inbox)
 *   title       — short headline (e.g. "No posts yet")
 *   description — single sentence below the title
 *   action      — optional CTA element rendered below
 *   dense       — smaller padding for in-table usage
 *   sx          — override
 */
const EmptyState = ({icon, title, description, action, dense = false, sx}) => {
    const IconEl = icon ?? <InboxOutlined sx={{fontSize: 32, color: t.color.text.muted}}/>;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                py: dense ? 4 : 7,
                px: 3,
                gap: 1,
                ...sx,
            }}
        >
            <Box
                sx={{
                    width: dense ? 40 : 56,
                    height: dense ? 40 : 56,
                    borderRadius: '50%',
                    backgroundColor: t.color.sidebarHover,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 0.5,
                }}
            >
                {IconEl}
            </Box>
            {title && (
                <Typography
                    sx={{
                        fontSize: `${t.type.h3.size}px`,
                        fontWeight: t.type.h3.weight,
                        color: t.color.text.primary,
                    }}
                >
                    {title}
                </Typography>
            )}
            {description && (
                <Typography
                    sx={{
                        fontSize: `${t.type.small.size}px`,
                        color: t.color.text.secondary,
                        maxWidth: 420,
                        lineHeight: 1.5,
                    }}
                >
                    {description}
                </Typography>
            )}
            {action && <Box sx={{mt: 1}}>{action}</Box>}
        </Box>
    );
};

export default EmptyState;
